import React, { useMemo } from "react";
import Chart from "react-apexcharts";

const RadialBar = ({
  series = [0],
  color = "#20E647",
  label = "Progress",
  size = 240,
}) => {
  // Scale text relative to chart size
  const valueFontSize = Math.round(size * 0.15); // 12.5% of width
  const nameFontSize = Math.round(size * 0.055); // ~5.5% of width

  const options = useMemo(
    () => ({
      chart: {
        type: "radialBar",
        sparkline: { enabled: true },
      },
      colors: [color],
      plotOptions: {
        radialBar: {
          hollow: {
            size: "70%",
            background: "#fff",
          },
          track: {
            dropShadow: {
              enabled: true,
              top: 2,
              left: 0,
              blur: 4,
              opacity: 0.15,
            },
          },
          dataLabels: {
            name: {
              offsetY: -10,  // closer to value (was -10)
              color: color,
              fontSize: `${nameFontSize}px`,
            },
            value: {
              offsetY: 5,   // small positive offset to pull closer to name
              color: "#000",
              fontSize: `${valueFontSize}px`,
              show: true,
            },
          },
        },
      },
      fill: {
        type: "gradient",
        gradient: {
          shade: "dark",
          type: "vertical",
          stops: [0, 100],
        },
      },
      stroke: {
        lineCap: "round",
      },
      labels: [label],
    }),
    [color, label, size, valueFontSize, nameFontSize]
  );

  return (
    <div className="donut">
      <Chart
        options={options}
        series={Array.isArray(series) ? series : [series]}
        type="radialBar"
        width={size}
      />
    </div>
  );
};

export default RadialBar;
